import React from 'react';

import MediaTypography from 'components/MediaTypography';

import IndividualityItemValue from './Value';
import {
	StyledIndividualityItemImage,
	StyledIndividualityItemValuesWrap,
	StyledIndividualityItemWrap,
} from './styled';

interface PropsType {
	type: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
	title: string;
	items: string[];
	imageSrc: string;
}

function IndividualityItem({ type, title, items, imageSrc }: PropsType) {
	return (
		<StyledIndividualityItemWrap>
			<StyledIndividualityItemImage src={imageSrc} alt="Individuality Block image" />
			<MediaTypography variants={{ sm: 'h3' }} variant="h2">
				{title}
			</MediaTypography>
			{items && items?.length > 0 && (
				<StyledIndividualityItemValuesWrap>
					{items.map((item) => (
						<IndividualityItemValue label={item} type={type} key={item} />
					))}
				</StyledIndividualityItemValuesWrap>
			)}
		</StyledIndividualityItemWrap>
	);
}

export default IndividualityItem;
